// extracted by mini-css-extract-plugin
export default {"root":"JPr0EsEy","content":"Jrrh2z9D","notFoundTitle":"RHb5dpQR","notFoundSubTitle":"dxuIgWCy","notFoundText":"aeoJ8KQi","linkText":"b1SWw9Tm","linkGoHome":"rU0BnLIj"};